import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { Injectable } from '@tanbo/vue-di-plugin'
import { Group } from '@/views/dashboard/_type/group'

export interface updateGroupOptions {
  /** 分组名 */
  name: string
  /** 父分组id（新增时必填） */
  parent_id?: number
  /** ip规则,范围起始用"-"分隔，多个区间用","分隔 */
  ip_rule: string
  /** 规则范围,0-仅未分组和新加入终端,1-全网终端 */
  rule_type: number
  /** 分组id（编辑时必填） */
  group_id?: number
  /** 分组备注 */
  remark?: string
  /** 自动分组规则列表（按 rule_type 全量替换；规则内容为空表示删除该类型规则） */
  rules?: Rules[]
}

export interface GroupOptions {
  team_id: number,
  system_types?: number[]
}
export interface Rules {
  /** 规则类型 1-IP 2-MAC 3-计算机名 */
  rule_type: number
  /** 规则内容（逗号分隔：IP-单IP/IP段/CIDR；MAC-精确或前缀；计算机名-通配符*?） */
  rule_value: string
  /** 状态 1-启用 2-停用；为0时默认启用 */
  status?: number
}
export interface RulesItem {
  /** 规则id */
  id: string
  /** 分组id */
  group_id: string
  /** 规则类型 1-IP 2-MAC 3-计算机名 */
  rule_type: number
  /** 规则内容 */
  rule_value: string
  /** 状态 1-启用 2-停用 */
  status: number
  /** 创建时间(unix秒) */
  create_time: string
  /** 更新时间(unix秒) */
  update_time: string
}

export interface RuleResponseData {
  /** 规则列表 */
  rules?: RulesItem[]
}
@Injectable()
export class GroupService {
  constructor (private http: Http) {
  }

  @InvokeThrottle()
  addGroup (options: updateGroupOptions) {
    return this.http
      .post<{ group_id: number}>('terminal-group/add', options)
  }

  @InvokeThrottle()
  delGroup (options: { group_id: number }) {
    return this.http
      .post<{
        group_id: string,
      }>('terminal-group/del', options)
  }

  @InvokeThrottle()
  editGroup (options: updateGroupOptions) {
    return this.http
      .post<{
        group_id: string,
      }>('terminal-group/update', options)
  }

  getGroupList (params: GroupOptions, url) {
    return this.http.post<{
      group: Group
    }>(url, params)
  }
  downloadTemplate (moduleName: string) {
    return this.http.downloadWithBlob('/terminal-group/download-template', {file_type:1}, moduleName)
  }
  importTemplate (data: FormData, config?: { headers?: any }) {
    // FormData 应该直接传递，不要包装在对象中
    // 使用 postForm 方法处理 multipart/form-data
    return this.http.postForm<{
      total: number
      success: number
      created_groups: any[]
      failed_groups?: any
    }>('/terminal-group/import', data, () => {}, {
      headers: {
        ...config?.headers
      }
    })
  }
  getTerminalGroupRuleGet (data: {group_id: number}) {
    return this.http.post<RuleResponseData>('/terminal-group/rule/get', data)
  }
  exportGroupInfo (type: 0 | 1, teamId: number, moduleName: string) {
    return this.http.downloadWithBlob('/terminal-group/export', {
      file_type: type,
      team_id: teamId
    }, moduleName)
  }
}
